import { ProgressStyleConfig } from '../types';

export const styleConfig: ProgressStyleConfig = {
  baseStyle: {
    filledTrack: {
      bg: 'green.500',
    },
    track: {
      bg: 'grey.100',
    },
  },
  sizes: {
    xs: {
      track: { height: '0.5', borderRadius: 'xs' },
      filledTrack: { borderRadius: 'xs' },
    },
    sm: {
      track: { height: '1', borderRadius: 'sm' },
      filledTrack: { borderRadius: 'sm' },
    },
    // Currently, only the 'md'/'default' size is defined in the DLS design
    md: {
      track: { height: '1.5', borderRadius: 'sm' },
      filledTrack: { borderRadius: 'sm' },
    },
    lg: {
      track: { height: '3', borderRadius: 'md' },
      filledTrack: { borderRadius: 'md' },
    },
  },
  defaultProps: {
    size: 'md',
  },
};
